const IATA = ['zrh', 'bsl', 'gva'];

export const normPlace = (s) => (s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
  .replace(/ü/g, 'u').replace(/ö/g, 'o').replace(/ä/g, 'a').replace(/ß/g, 'ss').replace(/[^a-z0-9 ]+/g, ' ').replace(/\s+/g, ' ').trim();

const codeOf = (n) => IATA.find((c) => n.split(' ').includes(c));

export const placeMatches = (booking, route) => {
  const a = normPlace(booking); const b = normPlace(route);
  if (!a || !b) return false;
  if (a === b || a.includes(b) || b.includes(a)) return true;
  const ca = codeOf(a); const cb = codeOf(b);
  return !!ca && ca === cb;
};

// Airport detection for tariff zones: IATA code or airport word in the place string.
const AIRPORT_RE = /\b(zrh|bsl|gva|mlh|eap|muc|fra|stuttgart airport|str|mxp|lin|bgy|lyon airport|lys|inn|flughafen|airport|aeroport|aéroport|aeroporto|euroairport)\b/i;
export const isAirportPlace = (s) => AIRPORT_RE.test(String(s || ''));
export const tariffZone = (from, to) => (isAirportPlace(from) || isAirportPlace(to) ? 'airport' : 'city');

export const findRoute = (routes, from, to) => (routes || []).find((r) =>
  (placeMatches(from, r.from) && placeMatches(to, r.to)) || (r.both !== false && placeMatches(from, r.to) && placeMatches(to, r.from)));

// Night surcharge: true if HH:MM falls within [from, to) hours (window may wrap midnight).
export const isNight = (time, fromH = 22, toH = 6) => {
  if (!time) return false;
  const h = Number(String(time).split(':')[0]);
  if (Number.isNaN(h)) return false;
  return fromH > toH ? (h >= fromH || h < toH) : (h >= fromH && h < toH);
};
